// deviceDetails is a JSON object of the site's outputs/inputs keyed by pin number
export const parseDeviceDetails = (deviceDetails) => {
    if (!deviceDetails) return {};
    if (typeof deviceDetails === 'object') return deviceDetails;
    try {
        return JSON.parse(deviceDetails);
    } catch (e) {
        console.warn('Failed to parse deviceDetails', e);
        return {};
    }
}

// finds the output a CCTV integration is linked to (matched by pinName) and returns its current state.
// liveOutputPinStates (from a socket 'appPinStates' payload, parsed via parsePinStates) overrides the
// persisted pinState with the live value when a matching pin is found.
export const getLinkedOutputState = (rowData, liveOutputPinStates) => {
    const details = parseDeviceDetails(rowData.deviceDetails);
    const entry = Object.entries(details).find(([, p]) => p?.pinName === rowData.pinName);
    if (!entry) return null;
    const [pinKey, pin] = entry;

    let pinState = pin.pinState;
    const liveState = liveOutputPinStates?.find((p) => p.pin === Number(pinKey));
    if (liveState) {
        pinState = liveState.pinState;
    }

    return {
        pinKey,
        pinType: pin.type,
        isOn: pinState === 1,
        isActive: !!pin.active,
        label: pinState === 1 ? pin.pinStatusOff : pin.pinStatusOn,
        lastSwitch: pin.lastSwitchTime
    };
}
